import {materials} from "./materials";
import {link} from "./links";
import {video} from "./videos";

export const physicsMaterials = [
    {
        id: 1,
        materials: materials,
        links:link,
        video:video,
        menuItemId: 3
    },
]
